import { Lock, Sparkles, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";
import { analytics } from "@/lib/analytics";
import { ROUTES } from '@/lib/routes';

interface Props {
  featureKey: string; // translation key for feature name
  descKey: string;
}

export function LabPIUpgradeCard({ featureKey, descKey }: Props) {
  const { translate } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="rounded-xl border-2 border-dashed border-primary/20 bg-primary/5 p-5 space-y-3">
      <div className="flex items-center gap-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
          <Lock className="h-4 w-4 text-primary" />
        </div>
        <div>
          <p className="text-sm font-semibold">{translate(featureKey)}</p>
          <Badge variant="secondary" className="text-[10px] gap-1 mt-0.5">
            <Sparkles className="h-2.5 w-2.5" />
            Performance Intelligence
          </Badge>
        </div>
      </div>
      <p className="text-xs text-muted-foreground">{translate(descKey)}</p>
      <Button
        size="sm"
        variant="outline"
        className="gap-1.5 text-xs"
        onClick={() => {
          analytics.track("lab.upgrade_prompt_shown");
          navigate(ROUTES.SETTINGS_BILLING);
        }}
      >
        {translate("lab_pi_upgrade_cta")}
        <ArrowRight className="h-3 w-3" />
      </Button>
    </div>
  );
}

export function LabAIComingSoonCard() {
  const { translate } = useTranslation();
  return (
    <div className="rounded-xl border border-dashed bg-muted/20 p-5 text-center space-y-2">
      <Sparkles className="h-6 w-6 text-muted-foreground mx-auto" />
      <p className="text-sm font-medium text-muted-foreground">{translate("lab_ai_coming_soon_title")}</p>
      <p className="text-xs text-muted-foreground">{translate("lab_ai_coming_soon_desc")}</p>
    </div>
  );
}
